import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { HelpModule } from '../../lib/help.module'
import { HelpBreadrumbResolver } from './help-breadrumb.resolver'
import { HelpPage } from './help.page'
import { LoggedInResolver } from './is-logged-in.resolver'

@NgModule({
  declarations: [HelpPage],
  providers: [HelpBreadrumbResolver, LoggedInResolver],
  imports: [
    CommonModule,
    HelpModule,
    RouterModule.forChild([
      {
        path: AppPaths.Help,
        data: {
          title: 'Help & Support',
        },
        resolve: {
          breadcrumb: HelpBreadrumbResolver,
          isLoggedIn: LoggedInResolver,
        },
        component: HelpPage,
      },
    ]),
  ],
})
export class HelpPageModule {}
